import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Typography from "@mui/material/Typography";
import { ReactNode } from "react";
import {
  COLOR_GREY_12,
  COLOR_WHITE,
  BORDER,
  COLOR_GREY_2,
} from "shared/theme/colors";
import { flex } from "shared/theme/mixins";

export const StyledDrawer = styled(Drawer, {
  shouldForwardProp: (props) => props !== "width",
})<{ width?: number }>`
  .MuiDrawer-paper {
    width: ${(props) => props.width ?? 640}px;
    background-color: ${COLOR_GREY_2};
    color: ${COLOR_GREY_12};
  }
`;

export const StyledHead = styled(Box, {
  shouldForwardProp: (props) => props !== "isHeadingBottom",
})<{ isHeadingBottom?: boolean }>`
  ${(props) =>
    flex({
      jc: "space-between",
      ai: props.isHeadingBottom ? "flex-start" : "center",
      fd: props.isHeadingBottom ? "column" : "row",
    })};
  position: fixed;
  width: 600px;
  z-index: 10;
  padding: 1rem 1.5rem;
  background-color: ${COLOR_WHITE};
  border-bottom: ${BORDER()};

  ${(props) => props.isHeadingBottom && "padding-bottom: 0"};
`;

export const StyledTitle = styled(Typography)`
   margin-left: 1rem;
  font-size: 1.5rem;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 335px;
`;

export const StyledContent = styled(Box, {
  shouldForwardProp: (propName) => !["headingBottom"].includes(propName),
})<{ headingBottom?: ReactNode }>`
  margin-top: ${({ headingBottom }) => (headingBottom ? 121 : 73)}px;
  padding: 1rem 1.5rem;
  background-color: ${COLOR_GREY_2};
`;
